import { createContext } from 'react';

const loopContext = createContext();

export default loopContext;